import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledProductsPage = styled('div')`
  .d-flex {
    display: flex;
  }

  .admin_farms {
    width: 200px;
  }

  .flex-rcol {
    display: flex;
    flex-direction: column;
  }

  .grey-price {
    color: ${(props) => props.theme.grey};
  }

  .admin {
    align-items: flex-end;
  }

  .ant-table-tbody {
    .ant-table-row {
      .ant-table-cell:nth-child(1) {
        width: 200px;
      }
    }
  }

  .actions-container {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  @media only screen and (min-width: ${breakpoints.lg}px) {
    table {
      width: 100% !important;

      .ant-table-thead {
        .ant-table-cell {
          white-space: nowrap !important;
          padding: 8px 12px !important;
        }
      }

      .ant-table-row {
        .ant-table-cell {
          padding: 8px 12px !important;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-tabs-nav:has(.ant-tabs-nav-list > :not(:only-child)) {
      margin-top: 16px;
      &.ant-tabs-nav::before {
        display: none;
      }

      .ant-tabs-nav-wrap {
        display: none;
      }
    }
  }
`;

export const StyledMobileCategoryWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;
